<template>
  <div class="matrix-scroll">
    <div class="flex">
      <div style="width: 140px"></div>
      <div class="flex-1 flex justify-between ml-5" style="padding-right: 160px">
        <span>{{ firstLabel.text }}</span>
        <span>{{ lastLabel.text }}</span>
      </div>
    </div>
    <div v-for="(item, index) in issue.items" :key="item.id">
      <div class="flex items-center">
        <div class="option-title" style="width: 140px">
          <div v-html="item.content.richText"></div>
        </div>
        <div class="option-slider flex-1 ml-5">
          <el-slider
            :value="item.value"
            show-input
            :max="issue.max"
            :min="issue.min"
            ref="elSlider"
            @input="onSliderChange($event, item, index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatrixScroll',
  changeExpr: 'currentValue',
  computed: {
    currentValue() {
      return this.getCurrentValue()
    },
    firstLabel() {
      return this.issue.labels[0]
    },
    lastLabel() {
      const labels = this.issue.labels
      return labels[labels.length - 1]
    }
  },
  methods: {
    getCurrentValue(exclusiveItem) {
      return this.issue.items.reduce((preValue, item) => {
        if (exclusiveItem && exclusiveItem.id === item.id) {
          return preValue + 0
        }
        return preValue + parseInt(item.value)
      }, 0)
    },
    onSliderChange(value, item, index) {
      item.value = value
    }
  }
}
</script>
